<template>
  <h1>Detail</h1>
</template>
